import api from './api';

class SettingFeesAndTaxes {
    getSettingFeesAndTaxes() {
        return api.get('/admin/setting-fees-taxes/get-setting-fees-and-taxes');
    }

    saveDefault(dataForm) {
        return api.post('/admin/setting-fees-taxes/save-default', dataForm);
    }

    createException(dataForm) {
        return api.post('/admin/setting-fees-taxes/exception/create', dataForm);
    }

    updateException(id, dataForm) {
        return api.post('/admin/setting-fees-taxes/exception/update/' + id, dataForm);
    }

    deleteException(id) {
        return api.delete('/admin/setting-fees-taxes/exception/delete/' + id);
    }
}

export default new SettingFeesAndTaxes();
